import { combineReducers } from "redux";
import UpcomingReducer from "./reducers/upcomingReducer";

const rootReducer = combineReducers({
    UpcomingReducer
});

export default rootReducer;